import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import Tooltip from '@mui/material/Tooltip';
import React, { useEffect, useReducer, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { SPA_TYPE, TYPE_LIST } from '../../../../../constants/SpaConst';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { formDataValidate } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { addSpaTreatmentAPI, updateSpaTreatmentAPI } from '../../../../../utils/PropertyAPIUtils';
import {
  allHotelsSelector,
  allSpaCategoriesSelector,
  allSpaInfoSelector,
  fetchAllSpa,
  selectedHotelCurrencySelector,
} from '../../../../property/propertySlice';
import './Treatments-Create.scss';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';
import { getPreSignedUrl } from '../../../../../utils/PropertyAPIUtils';
import { convertFileToBase64 } from '../../../../../utils/commonUtils';
import { ASSET_TYPE_PROPERTY } from '../../../../../constants/PropertyConst';
import { ASSET_URL } from '../../../../../env/Configurations';
import {
  decodeMediaKeyValue,
  renderVideos,
  renderGifs,
  toMediaContent,
  processGifsForUpload,
} from '../../../../../utils/mediaUtils';


const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const TreatmentsCreate = (props) => {
  const dispatch = useDispatch();
  const currency = useSelector(selectedHotelCurrencySelector);
  const originalHotels = useSelector(allHotelsSelector);
  const originalCateogires = useSelector(allSpaCategoriesSelector);
  const originalSpaInfo = useSelector(allSpaInfoSelector);
  const [categoryInSpa, setCategoryInSpa] = useState([]);
  const [treatmentType, setTreatmentType] = useState(TYPE_LIST);
  const [customDuration, setCustomDuration] = useState([]);
  const [isEditCustomDuration, setIsEditCustomDuration] = useState({
    isEdit: false,
    customIndex: -1,
  });
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [durationError, setDurationError] = useState(false);
  const [priceError, setPriceError] = useState(false);
  const [duplicateEntryError, setDuplicateEntryError] = useState(false);
  const [duration0MinError, setDuration0MinError] = useState(false);
  const { toggleDrawer, treatment, hotelId, showLoader = () => {} } = props;
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [rawVideos, setRawVideos] = useState([]);
  const [rawGifs, setRawGifs] = useState([]);
  const [videoImageUrl, setVideoImageUrl] = useState('');
  const [gifImageUrl, setGifImageUrl] = useState('');
  const [hasVideoError, setHasVideoError] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGifLoading, setIsGifLoading] = useState(false);
  const groupId = originalHotels?.find((h) => h?.id === hotelId)?.groupId;

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    spaId: {
      value: '',
      fieldName: 'Select Spa',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    spaCategoryId: {
      value: '',
      fieldName: 'Select Category',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    disclaimer: {
      value: '',
      fieldName: 'Disclaimer',
      errors: {},
      validations: [],
      tab: 0,
    },
    type: {
      value: 'UNISEX',
      fieldName: 'Type',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    redirectUrl: {
      value: '',
      fieldName: 'Redirect URL',
      errors: {},
      validations: ['validUrl', 'safeURL', 'safeDomain'],
      tab: 0,
    },
    isActive: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    durationMins: {
      value: '',
      fieldName: 'Duration (in mins)',
      errors: {},
      validations: [],
      tab: 1,
    },
    price: {
      value: '',
      fieldName: 'Price',
      errors: {},
      validations: [],
      tab: 1,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 2,
    },
  });

  useEffect(() => {
    if (treatment) {
      const currFields = { ...formData };
      const editTreatmentType = [...TYPE_LIST];
      const editTreatmentTypeMap = editTreatmentType?.map((item) => {
        item.ischecked = item.id === treatment?.type;
        return item;
      });
      setTreatmentType(editTreatmentTypeMap);
      for (let field in currFields) {
        currFields[field].value = treatment[field];
      }
      const tempCustomDuration = treatment?.duration?.map((durationItem) => {
        return {
          duration: durationItem?.duration,
          price: durationItem?.price,
          id: 'dragId' + Math.floor(Math.random() * 100000),
        };
      });
      setCustomDuration(tempCustomDuration);
      currFields.durationMins.value = '';
      currFields.price.value = '';
      currFields.images.value = treatment?.images || [];
      currFields.customAttributes.value = treatment?.customAttributes || [];
      const { Video: videoMediaContent, GIF: gifMediaContent } = decodeMediaKeyValue(
        treatment?.mediaContent,
      );
      const videoData = videoMediaContent || treatment?.videos || {};
      const gifData = gifMediaContent || treatment?.gifs || {};
      setVideoImageUrl(videoData?.imageUrl || '');
      setGifImageUrl(gifData?.imageUrl || '');
      setRawVideos(renderVideos(videoData));
      setRawGifs(renderGifs(gifData));
      setFormData(currFields);
    } else {
      const resetType = [...TYPE_LIST];
      const resetTypeMap = resetType?.map((item) => {
        // item.ischecked = false
        return item;
      });
      setTreatmentType(resetTypeMap);
    }
  }, [treatment]);

  useEffect(() => {
    const filteredCategories = originalCateogires?.filter(
      (category) => category.spaId === formData?.spaId.value,
    );
    setCategoryInSpa(filteredCategories);
  }, [formData.spaId.value]);

  const validate = (tabValue) => {
    let isDurationValid = true;

    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object?.entries(formData)?.filter(([key, field]) => field?.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid && isDurationValid;
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData?.images?.value];
    images.splice(index, 1);
    setFormData({ images });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate(0) && validate(1)) {
      toggleDrawer('', false, '');
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      setLoading(true);
      const payloadDuration = customDuration.map((durationItem) => {
        return {
          duration: durationItem.duration,
          price: durationItem?.price,
        };
      });
      const payload = {
        hotelId: hotelId,
        name: formData?.name?.value,
        code: formData?.code?.value,
        spaId: formData?.spaId?.value,
        spaCategoryId: formData?.spaCategoryId?.value,
        description: formData?.description?.value,
        redirectUrl: formData?.redirectUrl?.value,
        isActive: formData?.isActive?.value,
        customAttributes: formData?.customAttributes?.value,
        disclaimer: formData?.disclaimer?.value,
        type: formData?.type?.value,
        duration: payloadDuration,
      };
      try {
        dispatch(stepUpLoaderCount());
        payload.images = await getProcessedImages(
          rawImages,
          originalHotels?.find((hotel) => hotel?.id === hotelId)?.groupId,
          SPA_TYPE,
          hotelId,
        );
        const gifDataArr = await processGifsForUpload({
          rawGifs,
          groupId,
          propertyType: SPA_TYPE,
          hotelId,
        });

        payload.mediaContent = toMediaContent({
          videoList: rawVideos,
          videoImageUrl,
          gifList: gifDataArr,
          gifImageUrl,
        });
        payload.videos = { imageUrl: videoImageUrl || '' };
        payload.gifs = { imageUrl: gifImageUrl || '' };
        if (treatment) {
          payload.id = treatment?.id;
          await updateSpaTreatmentAPI(payload, language);
          notificationManager('success', 'Treatment updated successfully');
        } else {
          await addSpaTreatmentAPI(payload, language);
          notificationManager('success', 'Treatment created successfully');
        }
        dispatch(fetchAllSpa(hotelId));
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          treatment
            ? notificationManager('danger', 'Failed to update Treatment')
            : notificationManager('danger', 'Failed to create Treatment');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');
      if (!validate(0)) {
        setTabValue(0);
      }
      if (!validate(1)) {
        setTabValue(1);
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      if (validate(tabValue)) {
        setTabValue(newValue);
      }
    }
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  const onAddCustomDuration = async () => {
    setDurationError(false);
    setPriceError(false);
    setDuplicateEntryError(false);
    setDuration0MinError(false);

    const durationInt = Number(formData?.durationMins?.value);
    const priceInt = Number(formData?.price?.value);

    if (durationInt === 0 && priceInt === 0) {
      setDuration0MinError(true);
      return;
    }

    if (durationInt === 0) {
      setDurationError(true);
      return;
    }

    if (priceInt === 0) {
      setPriceError(true);
      return;
    }

    const currentInput = {
      duration: durationInt,
      price: priceInt,
      id: 'dragId' + Math.floor(Math.random() * 100000),
    };

    if (isEditCustomDuration?.isEdit) {
      const filterForDuplicate = customDuration?.filter((item) => {
        return item.duration === currentInput?.duration && item.price === currentInput?.price;
      });

      if (filterForDuplicate.length > 0) {
        setDuplicateEntryError(true);
      } else {
        const customDurationData = [...customDuration];
        customDurationData[isEditCustomDuration.customIndex] = currentInput;
        setCustomDuration(customDurationData);
        setIsEditCustomDuration({ isEdit: false, customIndex: -1 });
        const currFields = { ...formData };
        currFields.durationMins.value = '';
        currFields.price.value = '';
        setFormData(currFields);
      }
    } else {
      const filterForDuplicate = customDuration.filter((item) => {
        return item.duration === currentInput.duration && item.price === currentInput.price;
      });

      if (filterForDuplicate.length > 0) {
        setDuplicateEntryError(true);
      } else {
        setCustomDuration([...customDuration, currentInput]);
        const currFields = { ...formData };
        currFields.durationMins.value = '';
        currFields.price.value = '';
        setFormData(currFields);
      }
    }
  };

  const onClickEditDuration = async (e, durationKey, durationIndex) => {
    e.preventDefault();
    setIsEditCustomDuration({ isEdit: true, customIndex: durationIndex });
    formData.durationMins.value = durationKey.duration;
    formData.price.value = durationKey.price;
  };

  const onDeleteCustomDuration = async (e, durationIndex) => {
    e.preventDefault();
    const cd = [...customDuration];
    cd.splice(durationIndex, 1);
    setCustomDuration(cd);
  };

  const handleTypeChange = (e, typeKey, typeNdx) => {
    const typeArray = [...treatmentType];
    let tempType = '';
    let typeArrayChecked = typeArray.map((item) => {
      item.ischecked = false;
      return item;
    });
    typeArrayChecked[typeNdx].ischecked = e.target.checked;
    const checkedArray = typeArrayChecked.filter((item) => item.ischecked === true);
    if (checkedArray.length > 0) {
      tempType = checkedArray[0].id;
    } else {
      tempType = 'UNISEX';
    }
    const tempTypeForm = {
      value: tempType,
      fieldName: 'Type',
      errors: {},
      validations: ['required'],
      tab: 0,
    };
    setFormData({ type: tempTypeForm });
    setTreatmentType(typeArrayChecked);
  };

  const reorder = (list, sourceIndex, destinationIndex) => {
    const result = [...list];
    const [removed] = result.splice(sourceIndex, 1);
    result.splice(destinationIndex, 0, removed);
    return result;
  };
  const onChangeType = (e) => {
    const currField = { ...formData?.type };
    currField.value = e?.target?.value;
    setFormData({ type: currField });
  };

  const onDragEnd = (dragResult) => {
    if (!dragResult.destination) return;
    const reorderedDuration = reorder(
      customDuration,
      dragResult?.source?.index,
      dragResult?.destination?.index,
    );
    setCustomDuration(reorderedDuration);
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field?.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form className='roomtype-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-5'>
            <span className='page-title'>{treatment ? 'Edit Treatment' : 'Add Treatment'}</span>
          </div>
          <div className='col-md-5'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Duration' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-2 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        {tabValue === 0 && (
          <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
            <h4 className='tab-title'>Details</h4>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomSelect
                  item={formData?.spaId}
                  handleInputChange={(e) => {
                    setFormData({ spaId: e });
                  }}
                  labelField='name'
                  valueField='id'
                  options={originalSpaInfo}
                  hideNullOption={originalSpaInfo?.length}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomSelect
                  item={formData?.spaCategoryId}
                  handleInputChange={(e) => {
                    setFormData({ spaCategoryId: e });
                  }}
                  labelField='name'
                  valueField='id'
                  options={categoryInSpa}
                  hideNullOption={categoryInSpa?.length}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData?.name}
                  handleInputChange={(e) => {
                    setFormData({ name: e });
                  }}
                  maxLength={100}
                  endAdornment={true}
                  characterCount={true}
                  multiline={true}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData?.code}
                  handleInputChange={(e) => {
                    setFormData({ code: e });
                  }}
                  maxLength={15}
                  endAdornment={true}
                  characterCount={true}
                  multiline={true}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12 mb-3'>
                <CustomTextField
                  item={formData?.description}
                  handleInputChange={(e) => {
                    setFormData({ description: e });
                  }}
                  multiline={true}
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12 mb-3'>
                <CustomTextField
                  item={formData?.disclaimer}
                  handleInputChange={(e) => {
                    setFormData({ disclaimer: e });
                  }}
                  maxLength={200}
                  multiline={true}
                  endAdornment={true}
                  characterCount={true}
                />
              </div>
            </div>
            <div className='col-md-6 mt-3 mb-2'>
              <div className='d-flex align-items-center'>
                <div className='page-title1'>Treatment Type<span className='text-red'> *</span></div>
                <Tooltip title='By default all treatment are set as Unisex' placement='right'>
                  <InfoIcon fontSize='small' className='ms-4' />
                </Tooltip>
              </div>
            </div>
            <div className='custom-upload  col-md-12 row'>
              <div>
                <div>
                  <RadioGroup
                    row
                    aria-label={formData?.type?.fieldName}
                    value={formData?.type?.value}
                    name={formData?.type?.fieldName}
                    className='document-type mb-3'
                  >
                    {treatmentType &&
                      treatmentType?.length > 0 &&
                      treatmentType?.map((typeKey, typeNdx) => (
                        <div className='col-md-3' key={typeNdx}>
                          <FormControlLabel
                            className='document-type'
                            key={typeNdx}
                            value={typeKey.id}
                            control={
                              <Radio
                                color='primary'
                                name='Treatment Type'
                                onChange={(e) => handleTypeChange(e, typeKey, typeNdx)}
                              />
                            }
                            label={typeKey?.name}
                          />
                        </div>
                      ))}
                  </RadioGroup>
                </div>
              </div>
            </div>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData?.redirectUrl}
                handleInputChange={(e) => {
                  setFormData({ redirectUrl: e });
                }}
                multiline={false}
              />
            </div>
            <div className='row'>
              <div className='col-md-3 mb-3'>
                <div className='d-flex align-items-center'>
                  <CustomCheckbox
                    item={formData?.isActive}
                    handleInputChange={(e) => {
                      setFormData({ isActive: e });
                    }}
                    color='primary'
                  />
                  <CustomToolTip
                    title='Deactivating this Treatment hides it from Guest app'
                    placement='right-end'
                  >
                    <InfoIcon fontSize='small' style={{ marginLeft: 8 }} />
                  </CustomToolTip>
                </div>
              </div>
            </div>
            <KeyValuePairList
              item={formData.customAttributes}
              onListChange={(e) => {
                setFormData({ customAttributes: e });
              }}
            />
          </div>
        )}
        {tabValue === 1 && (
          <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
            <h4 className='tab-title'>Duration</h4>
            <div className='row px-3 w-100 d-flex mt-4'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData?.durationMins}
                  handleInputChange={(e) => {
                    setFormData({ durationMins: e });
                  }}
                  type='number'
                  min={0}
                  max={10000}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData?.price}
                  handleInputChange={(e) => {
                    setFormData({ price: e });
                  }}
                  type='number'
                  min={0}
                  max={99999999}
                />
              </div>
              <div className='me-3 col-md-2 row' sx={{ my: 5 }}>
                <Button
                  variant='outlined'
                  color='primary'
                  onClick={() => onAddCustomDuration()}
                  size='large'
                  className='me-3'
                >
                  {isEditCustomDuration.isEdit ? 'Edit' : 'Add'}
                </Button>
              </div>
              <div className='m-1'>
                {durationError && (
                  <p className='text-red'>The "Duration" value should be greater than 0 </p>
                )}
                {priceError && (
                  <p className='text-red'>The "Price" value should be greater than 0</p>
                )}
                {duplicateEntryError && (
                  <p className='text-red'>Duplicate entries are not allowed.</p>
                )}
                {duration0MinError && (
                  <p className='text-red'>
                    The "Duration" and "Price" values should be greater than 0
                  </p>
                )}
              </div>
            </div>
            {customDuration && customDuration.length > 0 && (
              <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
                <Droppable droppableId='droppable'>
                  {(provided, snapshot) => (
                    <div
                      {...provided.droppableProps}
                      className='col-md-10 px-1 py-3'
                      ref={provided.innerRef}
                    >
                      {customDuration.map((durationKey, durationIndex) => (
                        <Draggable
                          key={durationKey?.id}
                          draggableId={durationKey?.id}
                          index={durationIndex}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className='col row custom-duration-box'
                            >
                              <div className='col-md-1'>
                                <IconButton aria-label='drag' disabled={true}>
                                  <DragIndicatorIcon fontSize='12' className='icon' />
                                </IconButton>
                              </div>
                              <div
                                className='col-md-4 text p-3 custom-underline'
                                style={{ marginRight: '30px' }}
                              >
                                {durationKey?.duration} Minutes
                              </div>
                              <div className='col-md-4 text p-3 custom-underline'>
                                {durationKey?.price} {currency}
                              </div>
                              <div className='col-md-1'>
                                <IconButton
                                  aria-label='edit'
                                  disabled={isEditCustomDuration?.isEdit}
                                  onClick={(e) =>
                                    onClickEditDuration(e, durationKey, durationIndex)
                                  }
                                >
                                  <EditIcon fontSize='12' className='icon' />
                                </IconButton>
                              </div>
                              <div className='col-md-1'>
                                <IconButton
                                  aria-label='delete'
                                  onClick={(e) => onDeleteCustomDuration(e, durationIndex)}
                                >
                                  <RemoveCircleIcon fontSize='12' className='icon' />
                                </IconButton>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            )}
          </div>
        )}
        {tabValue === 2 && (
          <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title '>Media</h4>
              <ImageUpload
                uploadedImages={formData?.images?.value}
                imgList={rawImages}
                onImageListUpdated={onImageListUpdated}
                onUploadedImageRemoval={onUploadedImageRemoval}
                onImagesLoading={(status) => {
                  setLoading(status);
                }}
                videoImageUrl={videoImageUrl}
                onVideoImageUrlChange={setVideoImageUrl}
                gifImageUrl={gifImageUrl}
                onGifImageUrlChange={setGifImageUrl}
                videoList={rawVideos}
                gifList={rawGifs}
                onVideoListUpdated={setRawVideos}
                onGifListUpdated={setRawGifs}
                hotelId={hotelId}
                groupId={groupId}
                propertyType={SPA_TYPE}
                onVideoError={setHasVideoError}
                onThumbnailUploading={setIsThumbnailUploading}
                onVideoLoading={setIsVideoLoading}
                onGifLoading={setIsGifLoading}
              />
            </div>
          </div>
        )}
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            {tabValue < 2 ? (
              <Button
                variant='contained'
                color='primary'
                onClick={onNextClick}
                size='large'
                className='me-3'
                disabled={isTabInValid || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading}
              >
                Next
              </Button>
            ) : (
              <Button
                disabled={loading || hasVideoError || isThumbnailUploading || isVideoLoading || isGifLoading}
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                className='me-3'
                size='large'
              >
                {treatment ? 'Update' : 'Add'}
              </Button>
            )}
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </form>
  );
};

export default TreatmentsCreate;
